import Config from '../ClientConfig';

function getData(client, url, params = {}) {
  return client.getData(url, params || {});
}

export function locationsList(client, params = {}) {
  return getData(client, Config.API_URL_REPORTS_V2_LOCATIONS_LIST, params);
}

export function salesSimpleBiSummary(client, params = {}) {
  return getData(client, Config.API_URL_REPORTS_V2_SALES + 'simple-bi-summary/', params);
}

export function salesTargetAttainment(client, params = {}) {
  return getData(client, Config.API_URL_REPORTS_V2_SALES + 'target-attainment/', params);
}

export function salesSummary(client, params = {}) {
  return getData(client, Config.API_URL_REPORTS_V2_SALES + 'summary/', params);
}

export function salesTop(client, params = {}) {
  return getData(client, Config.API_URL_REPORTS_V2_SALES + 'top/', params);
}

export function salesDailyPerformance(client, params = {}) {
  return getData(client, Config.API_URL_REPORTS_V2_SALES + 'daily-performance/', params);
}

export function salesByProduct(client, params = {}) {
  return getData(client, Config.API_URL_REPORTS_V2_SALES + 'by-product/', params);
}

export function salesByCombo(client, params = {}) {
  return getData(client, Config.API_URL_REPORTS_V2_SALES + 'by-combo/', params);
}

export function salesCategoryMixMtd(client, params = {}) {
  return getData(client, Config.API_URL_REPORTS_V2_SALES + 'category-mix-mtd/', params);
}

export function salesClassMixMtd(client, params = {}) {
  return getData(client, Config.API_URL_REPORTS_V2_SALES + 'class-mix-mtd/', params);
}

export function ordersList(client, params = {}) {
  return getData(client, Config.API_URL_REPORTS_V2_ORDERS + 'list/', params);
}

export function ordersDetail(client, params = {}) {
  return getData(client, Config.API_URL_REPORTS_V2_ORDERS + 'detail/', params);
}

export function ordersRecent(client, params = {}) {
  return getData(client, Config.API_URL_REPORTS_V2_ORDERS + 'recent/', params);
}

export function ordersInvoices(client, params = {}) {
  return getData(client, Config.API_URL_REPORTS_V2_ORDERS + 'invoices/', params);
}
